<template>
  <el-card class="h-full">
    <div v-if="isExam" class="h-full flex flex-col">
      <div
        class="flex items-center justify-end pb-10px border-b border-color-default border-dotted"
      >
        <div class="flex items-center mr-10px">
          <span
            class="border-color-primary border inline-block rounded-full w-16px h-16px mr-6px"
          ></span>
          已作答
        </div>
        <div class="flex items-center mr-10px">
          <span
            class="border-color-default border inline-block rounded-full w-16px h-16px mr-6px"
          ></span>
          未作答
        </div>
        <span class="mr-10px ">
          <span class="text-blue-500">{{ complete }}</span
          >/{{ total }}
        </span>
        <span class="text-34px text-red-500">{{ countdownDisplay }}</span>
      </div>
      <!-- 答题卡 -->
      <div>
        <div class="px-20px bg-color-primary w-141px m-auto cursor-pointer" @click="handelCard">
          答题卡{{ isOpen ? '收缩' : '展开' }}
          <i :class="isOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div :style="{ 'max-height': cardHeight, overflow: 'auto' }" class="card_animate">
          <div v-for="(item, index) in answerSheetList" :key="index">
            <template v-if="item.list.length">
              <div>{{ item.name }}</div>
              <div class="pl-15px flex flex-wrap">
                <span
                  v-for="(sortItem, sortIndex) in item.list"
                  :key="sortIndex"
                  class="w-36px h-36px rounded-full flex items-center justify-center mr-20px border my-10px cursor-pointer"
                  :class="
                    isValue(sortItem.ExamineeAnswerContent)
                      ? ['border-color-primary', 'text-primary-cus'].join(' ')
                      : 'border-color-default'
                  "
                  @click="scrollPosition(item.examType + '_' + sortIndex)"
                >
                  {{ sortIndex + 1 }}
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- 题目 -->
      <div class="flex-1 overflow-y-auto">
        <div v-for="(item, index) in answerSheetList" :key="index">
          <template v-if="item.list.length">
            <div>{{ item.name }}</div>
            <div>
              <div
                v-for="(sortItem, sortIndex) in item.list"
                :key="sortIndex"
                :id="item.examType + '_' + sortIndex"
              >
                <div>
                  {{ sortIndex + 1 }}、
                  <span>({{ item.examType | typeStr }})</span>
                  {{ sortItem.Topic }}
                </div>
                <div v-if="item.examType === 0" class="my-10px">
                  <el-radio-group v-model="sortItem.ExamineeAnswerContent">
                    <ByChoice
                      type="radio"
                      v-model="sortItem.ExamineeAnswerContent"
                      :optionsString="sortItem.TopicContent"
                      @change="saveAnswer(sortItem)"
                    />
                  </el-radio-group>
                </div>
                <div v-if="item.examType === 1" class="my-10px">
                  <ByChoice
                    v-model="sortItem.ExamineeAnswerContent"
                    :optionsString="sortItem.TopicContent"
                    @change="saveAnswer(sortItem)"
                  />
                </div>
                <div v-if="item.examType === 2" class="my-10px">
                  <el-radio-group v-model="sortItem.ExamineeAnswerContent">
                    <ByChoice
                      type="judge"
                      v-model="sortItem.ExamineeAnswerContent"
                      :optionsString="sortItem.TopicContent"
                      @change="saveAnswer(sortItem)"
                    />
                  </el-radio-group>
                </div>
                <div v-if="item.examType === 3" class="my-10px">
                  <el-input
                    class="!w-50"
                    v-model="sortItem.ExamineeAnswerContent"
                    maxlength="50"
                    show-word-limit
                    @blur="saveAnswer(sortItem)"
                  >
                  </el-input>
                </div>
                <div v-if="item.examType === 4" class="my-10px">
                  <el-input
                    v-model="sortItem.ExamineeAnswerContent"
                    type="textarea"
                    :rows="3"
                    maxlength="500"
                    show-word-limit
                    @blur="saveAnswer(sortItem)"
                  >
                  </el-input>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="text-center">
        <el-button
          size="small"
          type="primary"
          v-loading="formLoading"
          class="iconfont icon-save"
          :disabled="!!isCanSubmit"
          @click="save()"
          >提交试卷&nbsp;{{ isCanSubmit ? `(${isCanSubmit})` : '' }}</el-button
        >
      </div>
      <!-- 提交试卷 -->
      <el-dialog
        :visible.sync="submitDialog"
        @close="submitDialog = false"
        width="30%"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        v-dialogDrag
      >
        <span slot="footer" class="text-center">
          <el-button type="primary" size="small">确 定</el-button>
          <el-button @click="submitDialog = false" size="small">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-else class="h-full flex items-center justify-center">
      <template>
        <el-result
          :icon="isPass ? 'success' : 'warning'"
          :title="
            isPass
              ? `恭喜您通过考试，本次考试成绩：${paperTotalScore}分。`
              : `很遗憾，您未能通过此次考试，本次考试成绩：${paperTotalScore}分。请点击【补考】按钮进行补考！`
          "
        >
          <template slot="extra">
            <el-button v-if="!isPass" @click="reExamination" type="primary" size="small">补考</el-button>
            <el-button @click="back" type="primary" size="small">我知道了</el-button>
          </template>
        </el-result>
      </template>

      <!-- <el-result icon="success" title="试卷成功提交">
        <template slot="extra">
          <el-button @click="back" type="primary" size="small">我知道了</el-button>
        </template>
      </el-result> -->
    </div>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'
import DiyService from '@/modules/educational-training-management-sm/services/DiyService'
import { cloneDeep } from 'lodash'
import ByChoice from '../../components/examManageConstructionUnit/ByChoice'

export default {
  name: 'online-question',
  components: {
    ByChoice,
  },
  filters: {
    typeStr(examType) {
      switch (examType) {
        case 0:
          return '单选题'
        case 1:
          return '多选题'
        case 2:
          return '判断题'
        case 3:
          return '填空题'
        case 4:
          return '问答题'
        default:
          return ''
      }
    },
  },
  data() {
    return {
      isOpen: true,
      formLoading: false,
      submitDialog: false,
      isExam: true,
      isPass: null,
      paperTotalScore: 0,
      countdownDisplay: '00:00:00',
      timer: null,
      getTimer: null,
      formData: {},
      answerSheetList: [
        {
          examType: 0,
          name: '一、单选题(共5题，共10分)',
          list: [],
        },
        {
          examType: 1,
          name: '二、多选题(共5题，共10分)',
          list: [],
        },
        {
          examType: 2,
          name: '三、判断题(共5题，共10分)',
          list: [],
        },
        {
          examType: 3,
          name: '四、填空题(共5题，共10分)',
          list: [],
        },
        {
          examType: 4,
          name: '五、问答题(共5题，共10分)',
          list: [],
        },
      ],
      isCanSubmit: 0,
      isCanSubmitEnum: 0,
      isAutoSubmitted: false, // 添加标记，防止重复自动提交
    }
  },
  computed: {
    cardHeight() {
      return this.isOpen ? '270px' : 0
    },
    complete() {
      let count = 0
      this.answerSheetList.forEach((item) => {
        item.list.forEach((topic) => {
          topic.ExamineeAnswerContent ? (count += 1) : count + 1
        })
      })
      return count
      // if (!this.formData.examPapers) {
      //   return 0
      // }
      // const allList = this.formData.examPapers.reduce((pre, item) => {
      //   pre = [...pre, ...item.examPaperSourceCorrelations]
      //   return pre
      // }, [])
      // return allList.reduce((pre, item) => {
      //   if (
      //     item.ExamineeAnswerContent ||
      //     item.ExamineeAnswerContent === 0 ||
      //     item.ExamineeAnswerContent === false
      //   ) {
      //     pre = pre + 1
      //   }
      //   return pre
      // }, 0)
    },
    total() {
      // return Object.keys(this.formData).length
      return this.answerSheetList.reduce((pre, item) => {
        pre = pre + item.list.length
        return pre
      }, 0)
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  watch: {},
  created() {
    this.getTopic()
  },
  mounted() {},

  methods: {
    /**
     * @description 代替刷新操作
     */
    initPage() {
      const initData = cloneDeep(this.$options.data())
      Object.keys(initData).forEach((key) => {
        this[key] = initData[key]
      })
      this.getTopic()
      this.$forceUpdate()
    },

    // 返回
    async back() {
      if (this.pageTags && this.pageTags.length > 1) {
        await this.$store.dispatch(
          'System/pageTags',
          _.filter(this.pageTags, (i) => {
            return i.path !== '/educational-training-management-sm/exam-manage-construction-unit/online-question'
          })
        )
      }
      this.$router.go(-1)
    },
    // 补考
    async reExamination() {
      this.isExam = false
      if (dayjs() > dayjs(this.formData.ExamEndTime)) {
        this.$message.warning('考试时间已过，无法开始补考')
        return
      }
      if (dayjs() < dayjs(this.formData.ExamStartTime)) {
        this.$message.warning('考试未开始，无法开始补考')
        return
      }
      const params = {
        ApiEngineKey: 'start_exam',
        TaskId: this.formData.TaskId,
      }
      const [err, res] = await DiyService.getInterfaceList(params)
      if (!err && res.Code === 1) {
        if (this.$router.mode === 'hash') {
          this.initPage()
        } else {
          this.$router.replace({
            path: 'online-question',
            query: {
              id: res.Data.Id,
            },
          })
        }
      } else {
        this.$message.error(res.Msg)
      }
    },
    async getTopic() {
      const params = {
        ApiEngineKey: 'get_current_paper',
        PaperId: this.$route.query.id,
      }
      const [err, res] = await DiyService.getInterfaceList(params)
      if (!err && res.Code === 1) {
        res.Data?.TopicTypes.forEach((item) => {
          item.TopicContents.forEach((content) => {
            content.ExamineeAnswerContent = null
          })
        })
        this.formData = res.Data
        this.getTimer = setTimeout(() => {
          this.getEndTime()
        }, 5000)
        // 设置考试结束时间为当前时间加上考试时长
        const currentTime = new Date()
        const endTime = new Date(currentTime.getTime() + res.Data.ExamDuration * 60 * 1000) // ExamDuration 单位为分钟
        this.setTime(endTime.getTime(), true)
        const listTypes = res.Data.TopicTypes
        const copyAnswerSheetList = JSON.parse(JSON.stringify(this.answerSheetList))
        let typeIndex = 1
        copyAnswerSheetList.forEach((item) => {
          item.list =
            listTypes?.find((i) => {
              return item.examType === i.QuestionType
            })?.TopicContents || []
          const total = item.list.length
          const totalPoints = item.list.reduce((pre, i) => {
            pre = pre + i.Score
            return pre
          }, 0)
          if (item.list.length) {
            item.typeIndex = typeIndex
            typeIndex += 1
          }
          switch (item.examType) {
            case 0:
              item.name = `${utils.numToChines(
                item.typeIndex
              )}、单选题(共${total}题，共${totalPoints}分)`
              break
            case 1:
              item.name = `${utils.numToChines(
                item.typeIndex
              )}、多选题(共${total}题，共${totalPoints}分)`
              break
            case 2:
              item.name = `${utils.numToChines(
                item.typeIndex
              )}、判断题(共${total}题，共${totalPoints}分)`
              break
            case 3:
              item.name = `${utils.numToChines(
                item.typeIndex
              )}、填空题(共${total}题，共${totalPoints}分)`
              break
            case 4:
              item.name = `${utils.numToChines(
                item.typeIndex
              )}、问答题(共${total}题，共${totalPoints}分)`
              break
            default:
              break
          }
        })
        this.answerSheetList = copyAnswerSheetList
      } else {
        this.$message.error(res.Msg)
      }
    },
    save() {
      this.$confirm('试卷提交后不可修改，请认真核对考试答案', '是否确认提交试卷？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(async () => {
          clearInterval(this.timer)
          this.submit()
        })
        .catch(() => {})
    },
    async submit(isAuto = false) {
      if (this.formLoading) return
      if (isAuto && this.isAutoSubmitted) return

      this.formLoading = true
      if (isAuto) {
        this.isAutoSubmitted = true
      }

      try {
        this.formData.examTaskId = this.$route.query.id
        const params = {
          ApiEngineKey: 'submit_exam_paper',
          ...this.formData,
        }
        const [err, res] = await DiyService.getInterfaceList(params)
        if (!err && res.Code === 1) {
          this.isPass = res.Data.isPass
          this.paperTotalScore = res.Data.totalScore
          this.isExam = false
        } else {
          this.$message.error(res.Msg || '提交失败')
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error('提交失败，请重试')
      } finally {
        this.formLoading = false
      }
    },
    isValue(value) {
      if (value || value === 0 || value === false) {
        return true
      }
      return false
    },
    async getEndTime() {
      if (this.getTimer === null || !this.isExam) return

      // 从 countdownDisplay 获取剩余时间
      const [hours, minutes, seconds] = this.countdownDisplay.split(':').map(Number)
      const remainingMinutes = hours * 60 + minutes
      const isExactMinute = seconds === 0

      // 如果剩余时间小于等于5分钟，显示提示
      if (remainingMinutes <= 5 && remainingMinutes > 0 && isExactMinute) {
        if (remainingMinutes === 5 || remainingMinutes === 1) {
          this.$confirm(`距离考试结束还剩${remainingMinutes}分钟，请注意时间！`, '考试时间提醒', {
            confirmButtonText: '我知道了',
            type: 'warning',
            center: true,
            showClose: false,
            showCancelButton: false,
          }).catch(() => {}) // 忽略关闭弹窗的错误
        }
      }

      // 如果时间到了，显示提示并自动提交
      if (remainingMinutes === 0 && seconds === 0) {
        clearInterval(this.timer)
        if (this.isExam) {
          this.$confirm('考试时间已到，系统将自动提交试卷', '考试结束', {
            confirmButtonText: '确定',
            type: 'warning',
            center: true,
            showClose: false,
            showCancelButton: false,
          }).then(() => {
            this.submit(true)
          }).catch(() => {
            this.submit(true) // 无论如何都要提交
          })
        }
        return
      }

      // 继续定时检查
      this.getTimer = setTimeout(() => {
        this.getEndTime()
      }, 1000) // 每秒检查一次
    },
    setTime(endTime, updateSubmit = false) {
      const that = this
      if (updateSubmit) {
        this.isCanSubmitEnum = this.$options.data().isCanSubmitEnum
      }

      let hasShownMessage = false

      function updateCountdown() {
        if (!that.isExam) {
          clearInterval(that.timer)
          return
        }

        const now = new Date()
        const timeDiff = new Date(endTime) - now

        if (timeDiff <= 0) {
          clearInterval(that.timer)
          that.countdownDisplay = '00:00:00'

          // 只在第一次显示消息
          if (!hasShownMessage) {
            hasShownMessage = true
            that.$confirm('已经达到考试时间，系统自动交卷', '试卷已经提交', {
              confirmButtonText: '确定',
              type: 'success',
              center: true,
              showClose: false,
              showCancelButton: false,
            }).then(() => {
              // 确认后提交
              if (that.isExam && !that.isAutoSubmitted) {
                that.submit(true)
              }
            }).catch(() => {
              // 如果用户关闭弹窗，也要提交
              if (that.isExam && !that.isAutoSubmitted) {
                that.submit(true)
              }
            })
          }
          return
        }

        let hours = Math.floor(timeDiff / 3600000)
        let minutes = Math.floor((timeDiff % 3600000) / 60000)
        let seconds = Math.floor((timeDiff % 60000) / 1000)

        hours = hours < 10 ? `0${hours}` : hours
        minutes = minutes < 10 ? `0${minutes}` : minutes
        seconds = seconds < 10 ? `0${seconds}` : seconds

        that.countdownDisplay = `${hours}:${minutes}:${seconds}`

        if (timeDiff > that.isCanSubmitEnum && that.isCanSubmitEnum >= 0) {
          let minutes = Math.floor((that.isCanSubmitEnum % 3600000) / 60000)
          let seconds = Math.floor((that.isCanSubmitEnum % 60000) / 1000)
          minutes = minutes < 10 ? `0${minutes}` : minutes
          seconds = seconds < 10 ? `0${seconds}` : seconds
          that.isCanSubmit = `${minutes}:${seconds}`

          if (that.isCanSubmitEnum === 0) {
            that.isCanSubmit = 0
          }
          that.isCanSubmitEnum -= 1000
        }
      }

      updateCountdown()
      this.timer = setInterval(updateCountdown, 1000)
    },

    handelCard() {
      this.isOpen = !this.isOpen
    },
    scrollPosition(idCode) {
      const el = document.getElementById(idCode)
      el.scrollIntoView(true)
    },
    async saveAnswer(row) {
      // 做一题保存一次
      // taskExamAnswerId 等待返回
      // const data = {
      //   taskExamAnswerId: this.formData.taskExamAnswerId,
      //   updateTopicContent: row,
      // }
      // await onlineExamsApi.saveExamAnswerContent({ body: data })
    },
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (this.getTimer) {
      clearTimeout(this.getTimer)
      this.getTimer = null
    }
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (this.getTimer) {
      clearTimeout(this.getTimer)
      this.getTimer = null
    }
  },
}
</script>

<style scoped lang="scss">
.card_animate {
  overflow: hidden;
  transition: 0.5s;
}
.text-primary-cus {
  color: var(--systemMainColor);
}
::v-deep .el-card__body {
  height: 100%;
  padding: 10px;
}
</style>
